import "./footer.scss";

const ContactFooter = (props) => {
  const hairLine = () => {
    return (
      <hr
        style={{
          color: "#d3d3d3",
          margin: 20,
          height: "0px",
        }}
      />
    );
  };
  return (
    <div>
      {hairLine()}
      <div className="email-text-content">{props.html()}</div>
    </div>
  );
};

export default ContactFooter;
